import { render, staticRenderFns } from "./QrLoad.vue?vue&type=template&id=188c0cf7&scoped=true"
import script from "./QrLoad.vue?vue&type=script&lang=js"
export * from "./QrLoad.vue?vue&type=script&lang=js"
import style0 from "./QrLoad.vue?vue&type=style&index=0&id=188c0cf7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c0cf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188c0cf7')) {
      api.createRecord('188c0cf7', component.options)
    } else {
      api.reload('188c0cf7', component.options)
    }
    module.hot.accept("./QrLoad.vue?vue&type=template&id=188c0cf7&scoped=true", function () {
      api.rerender('188c0cf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelCode/components/QrLoad.vue"
export default component.exports